"use client";

import React, { FC, PropsWithChildren } from "react";
import {
  GlobalStateProvider,
  ShaApplicationProvider,
  AttachmentsEditorProvider,
  MainLayout,
  useNextRouter,
} from "@shesha-io/reactjs";
import { AppProgressBar } from "next-nprogress-bar";
import { useTheme } from "antd-style";
import { EnterpriseApplicationPlugin } from '@shesha-io/enterprise';

/* NEW_TOOLBOXCOMPONENT_IMPORT_GOES_HERE */

export interface IAppProviderProps {
  backendUrl: string;
}

export const AppProvider: FC<PropsWithChildren<IAppProviderProps>> = ({
  children,
  backendUrl,
}) => {
  const nextRouter = useNextRouter();
  const theme = useTheme();

  const noAuthRoutes = [
    "/no-auth",
    "/login",
    "/account/forgot-password",
    "/account/reset-password",
  ];
  const noAuth = Boolean(
    noAuthRoutes.find((r) => nextRouter.path?.includes(r))
  );

  // Configuration Studio draws its own explorer/editor surface, so it must not be nested inside
  // MainLayout. It still requires auth, hence a list separate from noAuthRoutes.
  const fullScreenRoutes = ["/configuration-studio"];
  const isFullScreen = Boolean(
    fullScreenRoutes.find((r) => nextRouter.path?.includes(r))
  );
  const withoutMainLayout = noAuth || isFullScreen;

  return (
    <GlobalStateProvider>
      <AppProgressBar height="4px" color={theme.colorPrimary} shallowRouting />
      <ShaApplicationProvider
        backendUrl={backendUrl}
        router={nextRouter}
        noAuth={false}
      >
        <EnterpriseApplicationPlugin>
          {/* 0.46.0 renamed StoredFilesProvider; the backend url now comes from app context. */}
          <AttachmentsEditorProvider ownerId={""} ownerType={""}>
            {withoutMainLayout ? (
              <>{children}</>
            ) : (
              <MainLayout noPadding>{children}</MainLayout>
            )}
          </AttachmentsEditorProvider>
        </EnterpriseApplicationPlugin>
      </ShaApplicationProvider>
    </GlobalStateProvider>
  );
};
